import cloneDeep from 'lodash/cloneDeep';
import { reactive } from 'vue';
import useFormErrors from '@/composables/form/form-errors';
export function useForm(modelBase) {
    const base = reactive(cloneDeep(modelBase));
    const original = reactive(cloneDeep(modelBase));
    const $ = reactive(cloneDeep(modelBase));
    const $e = useFormErrors();
    /**
     * Determine if the model is dirty.
     * @returns {boolean}
     */
    function isDirty() {
        return !deepEqual($, original);
    }
    /**
     * Update original model base
     * @param obj
     */
    function updateOriginal(obj) {
        Object.assign(original, cloneDeep(obj));
    }
    /**
     * Check if objects are equal
     * @param x
     * @param y
     * @returns {boolean}
     */
    function deepEqual(x, y) {
        return (x && y && typeof x === 'object' && typeof y === 'object') ?
            (Object.keys(x).length === Object.keys(y).length) &&
                Object.keys(x).reduce((isEqual, key) => isEqual && deepEqual(x[key], y[key]), true) : (x === y);
    }
    return {
        base,
        original,
        $,
        $e,
        isDirty,
        updateOriginal,
    };
}
